import { apiAxiosV2 } from '@/configs/axios';
import { UploadService } from './UploadService';
// type V2CreateSupportTicketReq struct {
// 	*authModel.DefaultUserScope
// 	//required:true
// 	//in:header
// 	PackageName string `json:"x-pn"`
// 	//required:true
// 	//in:header
// 	Language string `json:"x-language"`
// 	//required:true
// 	//in:body
// 	Subject string `json:"subject"`
// 	//required:true
// 	//in:body
// 	Description string `json:"desc"`
// 	//required:true
// 	//in:body
// 	EmailID string `json:"email"`
// 	//required:true
// 	//in:body
// 	Phone string `json:"phone"`
// 	//required:true
// 	//in:body
// 	EntityID string `json:"entity_id"`
// 	//required:true
// 	//in:body
// 	CustomFields map[string]interface{} `json:"custom_fields"`
// 	//in:body
// 	Attachments []string `json:"attachment_uids"`
// 	//required:true
// 	//in:body
// 	Type TicketEntityType `json:"type"`
// 	//required:true
// 	//in:body
// 	Category TicketCategory `json:"category"`
// }

// type V2GetSupportTicketReq struct {
// 	*authModel.DefaultUserScope
// 	TicketID string
// }

//swagger:parameters ListTicketIDsReq
// type V2ListTicketIDsReq struct {
// 	//swagger:ignore
// 	*authModel.DefaultUserScope
// 	Pagination
// }
export const SupportService = {
  /**
   *
   * @param {{email:string, subject: string, message: string, offerId: string, attachments:[]}} param0
   */
  async raiseSupportTicket({
    email,
    subject,
    message,
    offerId,
    category = 'OTHERS',
    attachments = []
  }) {
    let attachment_uids = [];
    if (attachments?.length) {
      const promises = attachments.map(file => {
        return UploadService.uploadRaw(file);
      });
      const res = await Promise.all(promises);
      attachment_uids = res.map(r => r?.path);
    }
    const url = `/support-tickets/create`;
    const payload = {
      type: offerId ? 'OFFERWALL_OFFER' : 'APP',
      ...(!!offerId && {
        custom_fields: {
          cf_offer_id: offerId
        }
      }),
      category,
      email,
      subject,
      desc: message,
      attachment_uids
    };

    const res = await apiAxiosV2.post(url, payload);
    return res.data;
  }
};
